module.exports = {"content":{},"productInfo":{"code":"{F5DCDD19-86A1-4FE9-99EF-E58B32F037C3}","name":"英語 （アメリカ）　初中級","serialHead":"BMERJ","courseResourceIDs":[{"levelNo":1,"resourceID":"f85c1b4687f015b7209170d25a54cf7d78cfa1c2"},{"levelNo":2,"resourceID":"e03f6cc8ce17fd52cabe72aa7dc5a0a38fedc159"},{"levelNo":3,"resourceID":"bed76f2b77ee5db98ce0801a50e99a6001581652"},{"levelNo":4,"resourceID":"fd473bc92ac23328c286df0979592dcea852a4e9"},{"levelNo":5,"resourceID":"01c61ae368fa6a580b5b27271289f303a0d51c22"}],"language":"en-US","challengeCount":33869},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1